import {
	Component,
	OnInit,
	Input,
	ViewChild,
	Output,
	EventEmitter,
	OnChanges,
	SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';

import { MatMenu } from '@lenovo/material/menu';
import { DialogService } from 'src/app/services/dialog/dialog.service';
import { IMenuItem } from 'src/app/services/config/menu-item.interface';
import { ModernPreloadService } from 'src/app/services/modern-preload/modern-preload.service';
import { CommonService } from 'src/app/services/common/common.service';
import { LoggerService } from 'src/app/services/logger/logger.service';

@Component({
	selector: 'vtr-material-menu-dropdown',
	templateUrl: './material-menu-dropdown.component.html',
	styleUrls: ['./material-menu-dropdown.component.scss'],
	exportAs: 'materialMenuDropdownComponent',
})
export class MaterialMenuDropdownComponent implements OnChanges {
	@ViewChild(MatMenu, { static: true }) matMenu: MatMenu;
	@Input() dropdownMenu: IMenuItem;
	@Input() parentPath: string;
	@Input() parentId: string;
	hasSecondaryMenu = false;
	singleColumnSecondaryMenu = false;
	singleColumnSecondaryMenuItems: Array<any>;
	siggleColumnSecondaryMenuItemCategoryPath;

	constructor(
		private router: Router,
		public dialogService: DialogService,
		public commonService: CommonService,
		public modernPreloadService: ModernPreloadService
	) {}
	ngOnChanges(changes: SimpleChanges): void {
		if (changes.dropdownMenu !== undefined) {
			if (Array.isArray(this.dropdownMenu?.subitems)) {
				this.dropdownMenu.subitems.forEach((element) => {
					if (
						Array.isArray(element?.subitems) &&
						element.hide === false &&
						element.subitems.some((item) => item.hide === false)
					) {
						this.hasSecondaryMenu = true;
					}
				});
			}

			if (this.hasSecondaryMenu) {
				let visibleColumnCount = 0;
				let items;
				let parentPath;
				this.dropdownMenu.subitems.forEach((element) => {
					if (Array.isArray(element?.subitems) && element.hide === false) {
						let item = element.subitems.find((item) => item.hide === false);
						if (item) {
							visibleColumnCount++;
							items = element.subitems;
							parentPath = element.path;
						} else {
							element.hide = true;
						}
					}
				});

				if (visibleColumnCount === 1) {
					this.singleColumnSecondaryMenu = true;
					this.singleColumnSecondaryMenuItems = items;
					this.siggleColumnSecondaryMenuItemCategoryPath = parentPath;
				} else {
					this.singleColumnSecondaryMenu = false;
					this.singleColumnSecondaryMenuItems = null;
					this.siggleColumnSecondaryMenuItemCategoryPath = null;
				}
			}
		}
	}
	public openExternalLink(link) {
		if (link) {
			window.open(link);
		}
	}

	menuItemKeyDown(path, subpath?, secondaryPath?) {
		secondaryPath
			? this.router.navigateByUrl(`/${path}/${subpath}/${secondaryPath}`)
			: subpath
			? this.router.navigateByUrl(`/${path}/${subpath}`)
			: path
			? this.router.navigateByUrl(`/${path}`)
			: this.router.navigateByUrl(`/`);
	}

	OnClick(item) {
		if (item) {

			if (item.outletLink) {
				return;
			}

			if (item.path) {
				this.router.navigateByUrl(item.path);
			}
		}
	}
	identify(index, item) {
		return item.id;
	}
}
